module.exports = __webpack_public_path__ + "img/AcademyShowAll.8355f693.png";